import { Card, Col, Row } from "antd";
import React from "react";
import { ImDownload3 } from "react-icons/im";

import "./ScreeningActLog.css";

function ScreeningActLog() {
  return (
    <div className="screening-act-log">
      <Card
        title="Screening Actions Log"
        extra={
          <button className="icon-text-btn">
            <ImDownload3 size={18} />
            <span>Download</span>
          </button>
        }
      >
        <Row>
          <Col span={24} className="col-container">
            <Row>
              <Col span={4}>
                <span>02/09/2021 01:59 PM</span>
              </Col>
              <Col span={8}>
                <p>
                  <strong>Applicant Screened</strong> by Lauren Obregon
                </p>
                <p>for Robert L. Sullivan</p>
              </Col>
            </Row>
          </Col>
        </Row>
      </Card>
    </div>
  );
}

export default ScreeningActLog;
